import * as React from 'react';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import InfoIcon from '@mui/icons-material/Info';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, Fab, Popover, Typography } from '@mui/material';

export const OnboardingProviderSupport: React.FC = () => {
  const { formatMessage } = useIntl();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
    setIsOpen(false);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 15,
        right: 15,
      }}
    >
      <Fab onClick={handleClick} color="primary">
        {isOpen ? <RemoveIcon /> : <InfoIcon />}
      </Fab>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            mt: -1,
          },
        }}
      >
        <Box sx={{ p: 4, maxWidth: 350 }}>
          <Typography sx={{ mb: 2 }}>
            {formatMessage({ id: 'onboardingProvidersSupport.message1' })}
          </Typography>
          <Typography sx={{ mb: 2 }}>
            {formatMessage({ id: 'onboardingProvidersSupport.message2' })}
          </Typography>
          <Typography> {formatMessage({ id: 'onboardingProvidersSupport.message3' })}</Typography>
        </Box>
      </Popover>
    </Box>
  );
};
